<template>
    <div class="find-password-container">
        <el-form ref="findPasswordForm" :rules="findPasswordRules" :model="findPasswordForm" class="login-form"
                 autocomplete="on"
                 label-position="left">
            <div class="login-wrap">
                <div class="login-main">
                    <div class="login-header">
                        <div class="login-logo"><img src="../../images/logo.png" alt="" style="width: 200px;"></div>
                        <div class="l-title">联众宏宇 Microsoft 365支持中心工单系统</div>
                    </div>
                    <div class="login-cell">
                        <div class="login-inner">
                            <el-form-item prop="oldPswd" label="旧密码">
                                <el-input
                                        size="large"
                                        ref="oldPswd"
                                        v-model="findPasswordForm.oldPswd"
                                        placeholder="请输入旧密码"
                                        name="oldPswd"
																				type="password"
                                        tabindex="1"
                                        autocomplete="off"
                                        class="form-control"
                                />
                            </el-form-item>
                            <el-form-item prop="password" label="新密码">
                                <el-input
                                        size="large"
                                        key="password"
                                        ref="password"
                                        v-model="findPasswordForm.password"
                                        type="password"
                                        placeholder="请输入重置密码"
                                        name="password"
                                        tabindex="2"
                                        autocomplete="off"
                                />
                            </el-form-item>
                            <el-form-item prop="repeatPassword" label="重复密码">
                                <el-input
                                        size="large"
                                        key="repeatPassword"
                                        ref="repeatPassword"
                                        v-model="findPasswordForm.repeatPassword"
                                        type="password"
                                        placeholder="请再次输入密码"
                                        name="repeatPassword"
                                        tabindex="3"
                                        autocomplete="off"
                                        @keyup.enter.native="submitPassword"
                                />
                            </el-form-item>
                            <div class="l-button">
                                <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;"
                                           class="btn-login"
                                           @click.native.prevent="submitPassword">提交
                                </el-button>
                            </div>
                            <el-button type="text" style="color: #062c87;font-size: 16px;float: right" @click="onLogout">去登录
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import {getToken, removeToken} from "@/utils/auth";
import {resetPasswordByOldPassword} from "@/api/user";

export default {
        name: "ResetPassword",
        data() {
            // const validateUsername = (rule, value, callback) => {
            //     console.log(value);
            //     if (value.trim().length > 20) {
            //         callback(new Error('用户名最多20个字符'));
            //     } else if (!value.trim()) {
            //         callback(new Error('请输入注册邮箱'));
            //     } else {
            //         callback();
            //     }
            // }
            const validatePassword = (rule, value, callback) => {
                if (value.trim().length < 6) {
                    callback(new Error('请输入至少6位密码'));
                } else {
                    callback();
                }
            }
            const validateRepeatPassword = (rule, value, callback) => {
                if (value !== this.findPasswordForm.password) {
                    callback(new Error('两次密码不一致'))
                } else {
                    callback()
                }
            }
            return {
                findPasswordForm: {
					oldPswd: '',
                    password: '',
                    repeatPassword: ''
                },
                findPasswordRules: {
					oldPswd: [{required: true, trigger: 'blur', validator: validatePassword}],
                    password: [{required: true,trigger: 'blur', validator: validatePassword}],
                    repeatPassword: [{required: true, trigger: 'blur', validator: validateRepeatPassword}],
                },
                loading: false
            }
        },
        methods: {
            submitPassword() {
                this.$refs.findPasswordForm.validate(async valid => {
                    if (valid) {
                        try {
														this.loading = true;
														const {userId} = this.$store.state.user;
														await resetPasswordByOldPassword({userId: userId || getToken(),oldPswd:this.findPasswordForm.oldPswd,newPswd:this.findPasswordForm.password})
														removeToken();
														await this.$router.replace('/login');
                        } catch (e) {
                            console.error(e)
                        } finally {
                            this.loading = false;
                        }
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            },
						async onLogout() {
								removeToken();
								await this.$router.replace('/login');
						}
        }
    }
</script>

<style lang="scss" scoped>
    .find-password-container {
        min-height: 100%;
        width: 100%;
        background-color: white;
        overflow: hidden;

        .login-header {
            padding-top: 0;
        }

        .login-inner {
            padding-top: 20px;
        }
    }


</style>
